<template>
  <div id="myRegistration" v-show="showPage">
    <div style="width: 100%;height: calc(100vh - 60px);padding-bottom: 80px">
      <iframe id="myForm" frameborder="0" src="https://www.surveygizmo.com/s3/6181932/MyPKfit-2" width="100%" height="100%"></iframe>
    </div>
    <!-- iframe -->
    <div v-if="false">
      <iframe :src="iframeUrl" frameborder="0" style="width: 100%;"></iframe>
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>

<script>
import avatar from '@/assets/loading.gif'
import agreeBookDialog from "../login/agreeBookDialog";
import merge from 'webpack-merge';
export default {
  name: 'myRegistration',
  data () {
    return {
      showPage: false,
      ABDialogShow:false,
      openId: '',
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      oriUrl: this.$route.query.returnurl || '',
      takedacode: this.$route.query.takedacode || '',
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      HCPData: {}, // hcp信息
      iframeUrl: ''
    }
  },
  components: { agreeBookDialog },
  created () {
    this.coverGif()

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
if(!this.jumptovctag){
  this.iframeUrl = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myRegistration?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = this.iframeUrl
 }

      //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
      if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }

    if (!localStorage.TaToken && !this.takedacode) {
      this.iframeUrl = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myRegistration?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = this.iframeUrl
    } else {
      if (this.takedacode && !localStorage.TaToken) {
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          // 获取HCP状态
          this.getHCPStatus()
        })
      } else {
        this.openId = localStorage.openId
        // 获取HCP状态
        this.getHCPStatus()
      }
    }

      setTimeout(() => {
        this.getSignDetail();
        this.$router.push({
query:merge(this.$route.query,{'jumptovctag':''})
})
      }, 1500);


  },
  mounted () {
    let that = this
    this.$nextTick(() => {
      let iframe = document.getElementById('myForm')
      console.log(iframe, 'myForm')
      if (iframe.attachEvent) {
        iframe.attachEvent('onload', function () {
          that.disCover()
          that.showPage = true
        })
      } else {
        iframe.onload = function () {
          that.disCover()
          that.showPage = true
        }
      }
    })
  },
  methods: {
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
          //name: "agreeBook",
            this.ABDialogShow = true;
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    // 获取HCP状态
    getHCPStatus () {
      let data = {
        openid: this.openId,
        returnurl: encodeURIComponent(this.returnurl)
      }
      this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data).then(res => {
        console.log(res, 'getDoctor')
        if (res.isSuccess) {
          if (res.data.status) {
            // 已注册
            // 获取HCP信息
            // this.getHCPInfo()
          }
        }
      })
    },
    // 获取HCP信息
    getHCPInfo () {
      let data = {
        openId: this.openId
      }
      this.$axiox.postNoRes('/Login/WxUserInfo', data).then(res => {
        console.log(res, 'WxUserInfo')
        if (res.isSuccess) {
          this.HCPData = res.data
          console.log(this.HCPData, 'this.HCPData')
        }
      })
    },
    coverGif () {
      if (!document.getElementById('loadingGif')) {
        let dom = document.createElement('div')
        dom.id = 'loadingGif'
        let html = '<img src="' + avatar + '" height="144" width="192"/>'
        dom.innerHTML = html
        document.getElementById('app').appendChild(dom)
      }
    },
    disCover () {
      if (document.getElementById('loadingGif')) {
        document.getElementById('app').removeChild(document.getElementById('loadingGif'))
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/myPkFit/myRegistration.vue